/**
 * @generated SignedSource<<26c8a681f67460d712ed5d9a34dd67aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendPaymentRequestInput = {
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  accountName: string;
  contactID: string;
  salesOrderID: string;
  dueDate: any;
};
export type salesOrderSendPaymentRequestMutation$variables = {
  input: SendPaymentRequestInput;
};
export type salesOrderSendPaymentRequestMutation$data = {
  readonly sendPaymentRequest: {
    readonly success: boolean;
  } | null;
};
export type salesOrderSendPaymentRequestMutation = {
  variables: salesOrderSendPaymentRequestMutation$variables;
  response: salesOrderSendPaymentRequestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendPaymentRequestPayload",
    "kind": "LinkedField",
    "name": "sendPaymentRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesOrderSendPaymentRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "salesOrderSendPaymentRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9cb1a9674129a28d47d82d94f9c60bbc",
    "id": null,
    "metadata": {},
    "name": "salesOrderSendPaymentRequestMutation",
    "operationKind": "mutation",
    "text": "mutation salesOrderSendPaymentRequestMutation(\n  $input: SendPaymentRequestInput!\n) {\n  sendPaymentRequest(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc8a45eb602fa759cfd471c514194d8b";

export default node;
